
<app-card-table 
    [info]="info" 
    (buttonIsClicked)="buttonClicked($event)"
></app-card-table>